import { Box, TextField } from '@mui/material';
import { type INumberAttribute } from '../../../Interfaces/ILegalTransactionMeasure';

export const NumberAttribute = ({
  attribute,
  onUpdateAttribute,
}: {
  attribute: INumberAttribute;
  onUpdateAttribute: (attribute: INumberAttribute) => void;
}) => {
  return (
    <Box>
      <TextField
        sx={{ minWidth: '300px', backgroundColor: 'background.paper' }}
        size='small'
        type='number'
        fullWidth
        label={attribute.Name}
        value={attribute.Value}
        required={attribute.Required}
        onChange={e =>
          onUpdateAttribute({ ...attribute, Value: Number(e.target.value) })
        }
      />
    </Box>
  );
};
